/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Rigged(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8341 1.74999C17.1685 1.75034 18.2502 2.83251 18.2502 4.16698C18.25 5.28519 17.4894 6.2225 16.4582 6.49804V13.501C17.4896 13.7766 18.2502 14.7156 18.2502 15.834C18.2498 17.1681 17.1683 18.2496 15.8341 18.25C14.8082 18.25 13.933 17.6098 13.5822 16.708H6.41812C6.06759 17.6098 5.19296 18.2499 4.16714 18.25C2.83267 18.25 1.7505 17.1684 1.75015 15.834C1.75015 14.7612 2.44963 13.8518 3.41714 13.5361V6.46288C2.44984 6.14731 1.75029 5.23957 1.75015 4.16698C1.75015 2.8323 2.83246 1.74999 4.16714 1.74999C5.28535 1.75014 6.22363 2.51057 6.49918 3.54198H13.5011C13.7769 2.5105 14.7158 1.74999 15.8341 1.74999ZM4.16714 14.917C3.66088 14.917 3.25015 15.3277 3.25015 15.834C3.2505 16.3399 3.6611 16.75 4.16714 16.75C4.67304 16.7498 5.08281 16.3398 5.08316 15.834C5.08316 15.3278 4.67326 14.9172 4.16714 14.917ZM5.53336 6.15819C5.34533 6.28745 5.13845 6.39063 4.91714 6.46288V13.5361C5.68896 13.7882 6.28698 14.4186 6.4982 15.208H13.5021C13.5625 14.9822 13.6535 14.7698 13.7726 14.5752L7.38589 8.18749L7.47379 8.09862L5.53336 6.15819ZM9.60269 8.10644L9.51382 8.19433L14.9162 13.5967C14.9299 13.591 14.9443 13.5874 14.9582 13.582V6.41698C14.3284 6.17188 13.8284 5.67165 13.5832 5.04198H6.53921L9.60269 8.10644ZM15.8341 3.24999C15.3279 3.24999 14.9171 3.66072 14.9171 4.16698C14.9173 4.6731 15.328 5.083 15.8341 5.083C16.34 5.08265 16.75 4.67288 16.7502 4.16698C16.7502 3.66094 16.3401 3.25034 15.8341 3.24999Z"
        fill="#35424F"
      />
    </svg>
  )
}

Rigged.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Rigged
